// datatable related plugins
import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { formConvertErrorMessage } from "helpers/form_helper";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  deleteProductInvoice,
  getListProductInvoice,
  getListVat,
  resetCreateProductInvoice,
  resetDeleteProductInvoice,
  resetEditProductInvoice,
  resetListProductInvoice,
  setColumnVisibleProductInvoice,
} from "store/general-info/product/actions";
import {
  CREATE_PRODUCT_INVOICE_FAIL,
  CREATE_PRODUCT_INVOICE_SUCCESS,
  DELETE_PRODUCT_INVOICE_FAIL,
  DELETE_PRODUCT_INVOICE_SUCCESS,
  EDIT_PRODUCT_INVOICE_FAIL,
  EDIT_PRODUCT_INVOICE_SUCCESS,
} from "store/general-info/product/actionTypes";
import DetailData from "./DetailData";
import { getStatus } from "./helper/functionHelper";
import { modeDetail } from "./utils";

const ListData = props => {
  const [mode, setMode] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  const [idDetail, setIdDetail] = useState(null);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // store reducer
  const productInvoice = useSelector(state => state.productInvoice);
  const { loading, listData, totalCount, columnsVisible, params } =
    productInvoice.product;
  const history = useHistory();

  const { t, i18n } = useTranslation(["product"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));

  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (productInvoice.type) {
      case CREATE_PRODUCT_INVOICE_SUCCESS:
        addToast(
          t("message.create", {
            target: t("product"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListProductInvoice(params));
        dispatch(resetCreateProductInvoice());
        break;
      case CREATE_PRODUCT_INVOICE_FAIL:
        if (
          productInvoice.createProduct.error.code === 422 &&
          productInvoice.createProduct.error.fields.length > 0
        ) {
          productInvoice.createProduct.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("product"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateProductInvoice());
        break;

      case EDIT_PRODUCT_INVOICE_SUCCESS:
        addToast(
          t("message.update", {
            target: t("product"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListProductInvoice(params));
        dispatch(resetEditProductInvoice());
        break;
      case EDIT_PRODUCT_INVOICE_FAIL:
        if (
          productInvoice.editProduct.error.code === 422 &&
          productInvoice.editProduct.error.fields.length > 0
        ) {
          productInvoice.editProduct.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.update", {
                      target: t("product"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetEditProductInvoice());
        break;

      case DELETE_PRODUCT_INVOICE_SUCCESS:
        addToast(
          t("message.delete", {
            target: t("product"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleConfirmDeleteModal();
        dispatch(getListProductInvoice(params));
        dispatch(resetDeleteProductInvoice());
        break;
      case DELETE_PRODUCT_INVOICE_FAIL:
        addToast(
          t("message.delete", {
            target: t("product"),
            status: t("message.error"),
          }),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetDeleteProductInvoice());
        break;
      default:
        break;
    }
  }, [productInvoice.type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (tenantCodeHeader) {
      //   params.page = 1;
      dispatch(getListProductInvoice(params));
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (productInvoice.listVat) {
      initColumn();
    }
  }, [productInvoice.listVat]);

  useEffect(() => {
    dispatch(getListVat());
    return () => {
      dispatch(resetListProductInvoice());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      setMode(modeDetail.VIEW);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật",
      onClick: row => {
        setDataDetail(row);
        setMode(modeDetail.EDIT);
        toggleViewDetailModal();
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa",
      onClick: row => {
        setIdDetail(row.id);
        toggleConfirmDeleteModal();
      },
    },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  //   const getAuthStatus = (status, id) => {
  //     let infoError = null;
  //     if (
  //       status === AUTH_STATUS_REJECT ||
  //       status === AUTH_STATUS_RRE ||
  //       status === AUTH_STATUS_RR
  //     ) {
  //       infoError = (
  //         <i
  //           style={{ cursor: "pointer" }}
  //           title="Hiển thị lý do từ chối"
  //           className="font-size-17 bx bx-info-circle text-danger"
  //           onClick={() => {
  //             setIdRelease(id);
  //             toggleErrorReleaseModal();
  //           }}
  //         ></i>
  //       );
  //     }
  //     return (
  //       <React.Fragment>
  //         <div className="d-flex gap-1">
  //           <Badge
  //             className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
  //             pill
  //           >
  //             {commonStatus?.AUTH_STATUS[status]?.text}
  //           </Badge>
  //           {infoError}
  //         </div>
  //       </React.Fragment>
  //     );
  //   };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const numberWithCommas = (x, isShow) => {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Mã",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "name",
      text: "Tên/Mô tả",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "unit",
      text: "Đơn vị tính",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "price",
      text: "Đơn giá",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) => {
        return numberWithCommas(cellContent);
      },
    },
    {
      dataField: "id_vat",
      text: "Thuế suất",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      formatter: (cellContent, row) => {
        const vat = productInvoice.listVat.find(
          item => Number(item.id) === Number(cellContent)
        );
        if (vat) {
          return vat.label;
        } else if (row.vat_text) {
          return row.vat_text;
        }
        return "Chưa có thuế suất";
      },
    },
    {
      dataField: "checker_date",
      text: "Ngày tạo",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListProductInvoice(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListProductInvoice(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleProductInvoice(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getListProductInvoice(params));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách sản phẩm/ dịch vụ</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách sản phẩm/ dịch vụ" + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <ConfirmModal
                      isOpen={modalConfirmDelete}
                      titleHeader={"Xác nhận xóa sản phẩm/ dịch vụ"}
                      titleBody={
                        "Hệ thống sẽ thực hiện xóa sản phẩm/ dịch vụ này ?"
                      }
                      isDisableButton={productInvoice.deleteProduct.loading}
                      onConfirm={note => {
                        dispatch(deleteProductInvoice(idDetail));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmDeleteModal}
                    />
                    <DetailData
                      dataDetail={dataDetail}
                      listVat={productInvoice.listVat}
                      isOpenModal={modalDetail}
                      toggleModal={toggleViewDetailModal}
                      mode={mode}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          setDataDetail(null);
                          setMode(modeDetail.CREATE);
                          toggleViewDetailModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
